import React from 'react'
import images from 'Assets/Images'

export const BackgroundLogoUnstyled = props => (
  <div className={props.className}>
    <div className="background-image">
      <div className="background-filter-2" />
      <div className="background-filter-1" />
    </div>
    <img src={images.mainLogo} alt="Logo" />
  </div>
)



// WEBPACK FOOTER //
// ./src/Components/Sidebar/BackgroundLogo/unstyled.js